import React, { useState,useEffect } from "react";
import { configData } from "../config";
import { Link,useNavigate,useLocation ,useParams } from 'react-router-dom';
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';
import './classes/PackageList.css';

const PackageList = () => {

    const [isLoading, setIsLoading] = useState(true); 
    const [getPackages, setGetPackages] = useState([]);

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const location  = useLocation();
    const successMessage = location.state?.message; // Access the message
    window.history.replaceState({}, '');

    useEffect(() => {
        Promise.all([
           retrievepackagelist()
        ])
        .then(() => {
     
            setIsLoading(false);
        })
     
    },[]);
    async function retrievepackagelist() {
        const response = await fetch(
            app_url+'smwwcommerceproduct/getrelatepackagelist',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )           
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setGetPackages(responsedata.data.result);
        }
    }
    // useEffect(() => {
    //     // Fetch data from API
    //     const fetchedPackages = [
    //     { id: 1, name: 'Baseball Advanced Certificates' },
    //     { id: 2, name: 'Basketball Advanced Certificates'},
    //     { id: 3, name: 'Football Advanced Certificates'},
    //     ];
    //     setGetPackages(fetchedPackages);
    // }, []);

    return (
    <>
        {isLoading ? (
            <Loading />
        ) : (
            <div id="main">
                <Helmet><title>List Product Package</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                     {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                    <div className="product-list-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>Package Name</th>
                                    <th>Operations</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getPackages.map(productPackage => (
                                    <tr key={productPackage.value}>
                                    <td>{productPackage.label}</td>
                                    <td>
                                        <Link to={`/admin/smww-commerce/product-package-edit/${productPackage.value}`}>Edit</Link>| 
                                        <Link to={`/admin/smww-commerce/product-package-delete/${productPackage.value}`}>Delete</Link>
                                    </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="right">
                    <SalespersonSidebar />
                </div>
            </div>
        )}
    </>
    );
};
export default PackageList;